// extracted by mini-css-extract-plugin
export default {"link":"link-qtIaS","primary":"primary-0DFx1","error":"error-Wwbgr"};